import { contentConstants } from "./content-constants";
import { produce } from "immer";

function searchSubmitReducer(
  state = {
    searchLoading: null,
    searchResults: "",
    keyword: "",
    searchError: null,
  },
  action
) {
  switch (action.type) {
    case contentConstants.SEARCH_SUBMIT_START:
      return produce(state, (draftState) => {
        draftState.searchLoading = true;
        draftState.searchResults = action.payload;
        draftState.keyword = action.keyword;
      });

    case contentConstants.SEARCH_SUBMIT_SUCCESS:
      return produce(state, (draftState) => {
        draftState.searchLoading = false;
        draftState.searchResults = action.payload;
        draftState.keyword = action.keyword;
      });

    case contentConstants.SEARCH_SUBMIT_FAILURE:
      return produce(state, (draftState) => {
        draftState.searchLoading = false;
        draftState.searchError = action.payload;
        draftState.keyword = action.keyword;
      });

    default:
      return state;
  }
}

function faqReducer(state = {}, action) {
  switch (action.type) {
    case contentConstants.FAQS_SUBMIT_SUCCESS:
      return produce(state, (draftState) => {
        draftState.faqResults = action.payload;
      });

    case contentConstants.FAQS_SUBMIT_FAILURE:
      return produce(state, (draftState) => {
        draftState.faqError = action.payload;
      });

    default:
      return state;
  }
}

function linksReducer(state = {}, action) {
  switch (action.type) {
    case contentConstants.LINKS_SUBMIT_SUCCESS:
      return produce(state, (draftState) => {
        draftState.linksResults = action.payload;
      });

    case contentConstants.LINKS_SUBMIT_FAILURE:
      return produce(state, (draftState) => {
        draftState.linksError = action.payload;
      });

    default:
      return state;
  }
}

export { searchSubmitReducer, faqReducer, linksReducer };
